import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import AssignedClassesGroups from '../../assigned-classes-groups/index';

const AssignedGroupFormatter = ({ value = [] }) => (
    <AssignedClassesGroups assignedTo={value} showAssignButton={false} />
);

AssignedGroupFormatter.propTypes = {
    value: PropTypes.array
};

export default AssignedGroupFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/assigned-group-formatter/index.js